import { useMutation } from '@apollo/client';
import AuthHeadline from '../Components/AuthHeadline';
import AuthLayout from '../Components/AuthLayout';
import ResendVerification from '../Components/ResendVerification';
import Loader from 'Components/Forms/Loader';
import useMessages from 'hooks/useMessages';
import {
  RESEND_USER_VERIFICATION_MAIL,
  TOKENIZED_LOGIN,
} from 'graphql/auth/mutations/auth.mutations';
import React, { FC, useEffect, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { StringParam, useQueryParam } from 'use-query-params';

const TokenizedLogin: FC = () => {
  const navigate = useNavigate();
  const { setErrorMessage } = useMessages();
  const [loginCalled] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [token] = useQueryParam('token', StringParam);
  const [email] = useQueryParam('email', StringParam);

  const [login] = useMutation(TOKENIZED_LOGIN, {
    onError: error => {
      setError(error.message);
      setErrorMessage(error.message);
    },
    onCompleted: () => {
      setError(null);
      navigate('/');
    },
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (token && !loginCalled) {
      setLoading(true);
      login({ variables: { token } }).then(() => setLoading(false));
    }
    // eslint-disable-next-line
  }, [token, loginCalled]);

  if (loading || !email) return <Loader />;

  if (error) {
    return (
      <AuthLayout title="Register">
        <AuthHeadline text="Welcome to" highlighted="the transparency tool" />
        <ResendVerification
          title="Verification link expired"
          subtitle="The link you used is expired. Use the button below to get a new one."
          email={email}
          mutation={RESEND_USER_VERIFICATION_MAIL}
        />
      </AuthLayout>
    );
  }

  return <Navigate to="/" />;
};

export default TokenizedLogin;
